export const ALLOWED_IMAGE_LINK_DOMAINS = ['sharepoint.com'];
export const ALLOWED_IMAGE_MIME_TYPES = [
  'image/apng',
  'image/gif',
  'image/jpeg',
  'image/png',
  'image/svg+xml',
  'image/webp',
];

export const NO_IMAGE_PLACEHOLDER = '/images/no-image.png';
